import {
  Avatar,
  Icon,
  Menu,
  Message,
  Notification,
  Overlay,
} from '@alifd/next';
import axios from 'axios';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import commonhelper from '@/lib/commonhelper';
import { getNewMessage } from '@/redux/slices/userSlice';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Menu;
const { Popup } = Overlay;

const UserProfile = ({ user }) => {
  return (
    <div className={styles.profile}>
      <div className={styles.avatar}>
        <Avatar src={user.img} alt="用戶頭像" />
      </div>
      <div className={styles.content}>
        <h4>{user.name}</h4>
        <span>{user.email}</span>
      </div>
    </div>
  );
};

const HeaderAvatar = () => {
  const dispatch = useDispatch();
  const [hasQrcode, setHasQrcode] = useState(false);
  const [socketMsg, setSocketMsg] = useState([]);
  const [fullscreenStatus, setFullscreenStatus] = useState(false);
  const [popupStatus, setPopupStatus] = useState(false);
  const [user, setUser] = useState('');

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreenStatus(true);
      setPopupStatus(false);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setFullscreenStatus(false);
      setPopupStatus(false);
    }
  }
  const openNotification = (data) => {
    Notification.config({ placement: 'br' }); // tl,tr,bl,br
    Notification.open({
      title: data.title || '我是標題',
      content: data.content || 'Hellow World',
      class: data.class || 'message',
      type: data.type || 'notice', // success, warning, error, notice, help
      duration: data.duration || 4000,
      // icon: 'smile',
      style: {
        width: ' 90%',
        marginLeft: 55,
        background: '#c4dbff',
        borderRadius: '10px',
      },
      onClick: () => {
        console.log('Notification Clicked!');
        // openNotification({ txt:'再來一次...',userId:'Hahahahahhahahhahahahahahaha',type:'error' })
        if (data.redirect) history.push(data.redirect);
      },
      onClose: () => {
        console.log('Close Clicked!');
        // openNotification({ txt:'關的好',userId:'哈哈哈哈哈哈哈哈哈哈哈哈',type:'success' })
      },
    });
  };
  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        setUser(data.user);
        if (
          Object.prototype.hasOwnProperty.call(data.user, 'f_password') &
          Object.prototype.hasOwnProperty.call(data.user, 'expireTime')
        ) {
          setHasQrcode(true);
        } else {
          setHasQrcode(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    client.service('message').on('msg', (data) => {
      console.log('on header');
      if (
        Object.prototype.hasOwnProperty.call(data, 'objId') &&
        !socketMsg.includes(data.objId)
      ) {
        // 限制重複id message 只顯示1比
        const newArr = [...socketMsg];
        newArr.push(data.objId);
        setSocketMsg(newArr);

        // 測試custom event
        openNotification(data);
        dispatch(getNewMessage());
      }
    });
  }, []);

  return (
    <Popup
      trigger={
        <div className={styles.headerAvatar}>
          <Avatar size="small" src={user.img} alt="用戶頭像" />
        </div>
      }
      triggerType="click"
      visible={popupStatus}
      onVisibleChange={(visible) => {
        setPopupStatus(visible);
      }}
    >
      <div className={styles.avatarPopup}>
        <UserProfile user={user} />

        {hasQrcode === true ? (
          <div
            className={styles.testQR}
            onClick={() => {
              if (commonhelper.isApp()) {
                commonhelper.loadPath('/com');
              } else {
                window.location.href = '/account/#/com';
              }
            }}
          >
            此為測試帳號，尚未開通
          </div>
        ) : null}

        <Menu className={styles.menu}>
          <Item
            onClick={() => {
              history.push('/ezpro/person');
            }}
          >
            <Icon size="small" type="account" />
            個人設置
          </Item>

          <Item
            onClick={() => {
              history.push('/ezpro/systemSetting');
            }}
          >
            <Icon size="small" type="set" />
            推播設置
          </Item>
          {!commonhelper.isApp() ? (
            <Item
              onClick={() => {
                toggleFullScreen();
              }}
            >
              <Icon
                size="small"
                type={fullscreenStatus === false ? 'eye' : 'eye-close'}
              />
              {fullscreenStatus === false ? '切換全屏' : '關閉全屏'}
            </Item>
          ) : null}
          {/* {user.auth === 'superAdmin' && (
            <Item
              onClick={() => {
                history.push('/ezpro/updateSystem');
              }}
            >
              <Icon size="small" type="download" />
              系統更新
            </Item>
          )} */}
          {user.auth === 'superAdmin' && (
            <Item
              onClick={async () => {
                const Result = await axios(
                  `/ezcon/api/dataBackupPropertyWithoutDocker`,
                  {
                    method: 'GET',
                    headers: {
                      authorization: window.localStorage['feathers-jwt'],
                    },
                  }
                );
                if (Result) {
                  Message.success('檔案備份成功');
                }
              }}
            >
              <Icon size="small" type="upload" />
              系統備份
            </Item>
          )}
          {user.auth === 'superAdmin' && (
            <Item
              onClick={async () => {
                const Result = await axios(
                  `/ezcon/api/dataRestorePropertyWithoutDocker`,
                  {
                    method: 'POST',
                    headers: {
                      authorization: window.localStorage['feathers-jwt'],
                    },
                  }
                );
                if (Result) {
                  Message.success('還原成功');
                }
              }}
            >
              <Icon size="small" type="download" />
              系統還原
            </Item>
          )}
          <Item
            onClick={async () => {
              await client.logout().catch((err) => {
                console.log('==logout error:', err);
                localStorage.removeItem('feathers-jwt');
              });

              history.push('/user/login');
              commonhelper.pageReload();
            }}
          >
            <Icon size="small" type="exit" />
            登出
          </Item>
        </Menu>
      </div>
    </Popup>
  );
};

export default HeaderAvatar;
